<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'Cards',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'number',
        placeholder: '天数',
        type: 'input'
      }, {
        name: 'price',
        placeholder: '价格',
        type: 'input'
      }, {
        name: 'userName',
        placeholder: '用户',
        type: 'input'
      }, {
        name: 'encryptedCardSecret',
        placeholder: '加密卡密',
        type: 'input'
      }, {
        name: 'status',
        placeholder: '是否使用',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '是',
        }, {
          key: 0,
          value: '否',
        }]
      }],
      permission: {
        add: 'cards:add',
        update: 'cards:update',
        delete: 'cards:delete',
        deleteBatch: 'cards:deleteBatch'
      },
      url: {
        get: '/cards/listByCondition',
        add: '/cards/add',
        update: '/cards/update',
        delete: '/cards/delete',
        delete_batch: '/cards/deleteBatch',
        status: '/cards/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      }, {
        field: 'number',  // 字段名
        label: '天数',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'price',  // 字段名
        label: '价格',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'videoNumber',  // 字段名
        label: '视频数量',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'status',
        label: '是否使用',
        show: {
          type: 'tag',
          tags: [
            {
              key: 1,
              value: '是',
              type: 'success'
            }, {
              key: 0,
              value: '否',
              type: 'info'
            }
          ]
        },
        width: '80',
      }, {
        field: 'userName',  // 字段名
        label: '用户',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'usageTime',  // 字段名
        label: '使用时间',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'cardSecret',  // 字段名
        label: '卡密',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'encryptedCardSecret',  // 字段名
        label: '加密卡密',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'generationMethod',
        label: '生成方式',
        show: {
          type: 'tag',
          tags: [
            {
              key: 1,
              value: '系统生成',
            }, {
              key: 2,
              value: '用户购买',
            }
          ]
        },
        width: '80',
      },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          }, {
            field: 'number',  // 字段名
            label: '天数',  // 字段显示名称
            type: 'input',
            placeholder: '请输入天数',
            rules: [
              {required: true, message: '天数不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'price',  // 字段名
            label: '价格',  // 字段显示名称
            type: 'input',
            placeholder: '请输入价格',
            rules: [
              {required: true, message: '价格不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'videoNumber',  // 字段名
            label: '视频数量',  // 字段显示名称
            type: 'input',
            placeholder: '请输入视频数量',
            rules: [
              {required: true, message: '视频数量不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'quantityGenerated',  // 字段名
            label: '生成数量',  // 字段显示名称
            type: 'input',
            placeholder: '请输入生成数量',
            rules: [
              {required: true, message: '生成数量不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'userId',  // 字段名
            label: 'userId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入userId',
            rules: [
              {required: true, message: 'userId不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'status',  // 字段名
            label: 'status',  // 字段显示名称
            type: 'input',
            placeholder: '请输入status',
            rules: [
              {required: true, message: 'status不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'usageTime',  // 字段名
            label: 'usageTime',  // 字段显示名称
            type: 'input',
            placeholder: '请输入usageTime',
            rules: [
              {required: true, message: 'usageTime不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'cardSecret',  // 字段名
            label: 'cardSecret',  // 字段显示名称
            type: 'input',
            placeholder: '请输入cardSecret',
            rules: [
              {required: true, message: 'cardSecret不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'encryptedCardSecret',  // 字段名
            label: 'encryptedCardSecret',  // 字段显示名称
            type: 'input',
            placeholder: '请输入encryptedCardSecret',
            rules: [
              {required: true, message: 'encryptedCardSecret不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
